"use client";
import { Widget } from "./widget";
import StoreProvider from "../providers/store-provider";
import { WidgetPosition } from "./widget";
export const WidgetWithStore = (props: {
  position?: WidgetPosition;
  agentid: string;
  isPreview?: boolean;
}) => {
  return (
    <StoreProvider>
      <Widget {...props} />
    </StoreProvider>
  );
};
